<template>
  <v-container>
    <v-layout align-start
              justify-center
              row
              fill-height>
      <v-col cols="12">
        <v-card v-if="showHead" color="#1976d2">
          <v-card-title primary-title class="white--text">
            <div>
              <h3 class="headline mb-2">
                {{ tableName }}
              </h3>
            </div>
          </v-card-title>
        </v-card>
        <BaseDataTable ref="datatable"
                       :disabled="disabled"
                       :headers="headers"
                       :endpoint="endpoint"
                       :table-name="tableName"
                       :hide-actions="hideActions"
                       :header-key="headerKey"
                       :header-text="headerText"
                       :async="isAsync"
                       :table-data-external="tableDataExternal"
                       :is-loading="isLoading"
                       :is-searchable="isSearchable"
                       :alert="isAlert"
                       :multiple-edit="multipleEdit"
                       :enable-export="enableExport"
                       :show-head="showHead"
                       :group-by="groupBy"
                       :is-dragable="isDragable"
                       @editClick="editClick"
                       @deleteClick="onDelete">
          <template v-slot:button>
            <v-dialog ref="dialogWindow"
                      v-model="dialog"
                      max-width="800px"
                      persistent>
              <template v-slot:activator="{ on }">
                <v-row dense align="start" justify="end">
                  <slot name="additionalButton" />
                  <v-btn v-show="showBtn"
                         :disabled="disabled"
                         color="primary"
                         dark
                         class="mb-2"
                         icon
                         v-on="on"
                         @click="createRow">
                    <v-icon>add</v-icon>
                  </v-btn>
                  <v-btn v-if="multipleEdit"
                         v-show="!showBtn"
                         :disabled="disabled"
                         color="primary"
                         dark
                         class="mb-2"
                         icon
                         v-on="on"
                         @click="editMultiple">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </v-row>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-row justify="center">
                  <slot name="editVals" />
                </v-row>
              </v-card>
            </v-dialog>
          </template>
        </BaseDataTable>
      </v-col>
    </v-layout>
  </v-container>
</template>

<script>
import BaseDataTable from './BaseDataTable'

export default {
  name: "BaseCrudTable",
  components: {BaseDataTable},
  props: {
    tableName: {
      type: String,
      default: ''
    },
    endpoint: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    headers: {
      type: Array,
      default: () => []
    },
    hideActions: {
      type: Boolean,
      default: true
    },
    headerKey: {
      type: String,
      default: undefined
    },
    headerText: {
      type: String,
      default: undefined
    },
    isAsync: {
      type: Boolean,
      default: true
    },
    tableDataExternal: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    isSearchable: {
      type: Boolean,
      default: true
    },
    isAlert: {
      type: Boolean,
      default: false
    },
    multipleEdit: {
      type: Boolean,
      default: false
    },
    enableExport: {
      type: Boolean,
      default: true
    },
    showHead: {
      type: Boolean,
      default: true
    },
    groupBy: {
      type: String,
      default: undefined
    },
    keepDataFields:{
      type: Array,
      default: () => []
    },
    keepShowBtn: {
      type: Boolean,
      default: false
    },
    isDragable: {
      type: Boolean,
      default: true
    },
    disabled:{
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      dialog: false,
      editedItem: {
        name: '',
        id: ''
      },
      name: '',
      rules: {
        required: value => !!value || 'Required.'
      },
      formHasErrors: false,
      errorMessages: '',
      editedIndex: -1,
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Добавить' : 'Отредактировать'
    },
    form () {
      return {
        name: this.name
      }
    },
    showBtn () {
      return !(this.tableDataExternal.length>0) || this.keepShowBtn
    }

  },
  watch: {
    name () {
      this.errorMessages = ''
    }
  },
  methods: {
    save (newVal) {
      this.$refs["datatable"].save(newVal)
      this.dialog = false
    },
    saveLocal (newVal) {
      this.$refs["datatable"].saveLocal(newVal)
      this.dialog = false
    },
    clear () {
      this.$refs['datatable'].clear()
    },
    createRow () {
        let form = this.$scopedSlots.editVals()[0].context['editItem']
        let vm = this
        if (form) {
          Object.keys(form).forEach(f => {
                 if (vm.keepDataFields.indexOf(f)===-1 )vm.$set(form, f, '')
            })
        }
    },
    editMultiple () {
      let data = this.$parent.$refs['basetable'].tableDataExternal
      this.$emit('editMultiple', data)
    },
    editClick (val, index) {
      this.editedIndex = 1
      this.name = val.name
      this.editedItem.id = val.id
      this.dialog = true
      this.$emit('editClicked', val, index)
    },
    onDelete (index) {
      this.$emit('deleteClicked', index)
    },
    close () {
      this.editedIndex = -1
      this.dialog = false
    },
    submit () {
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true

        this.$refs[f].validate(true)
      })
      if (!this.formHasErrors) this.save()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/BaseCrudTable.vue